export const reportsData = {
  id: 1,
  name: "allReports",
  label: "Choose your report",
};

export const TabsTitles = {
  POSITIVE_COMMENTS: { title: "Positive comments", filter: "positive_comments" },
  AREAS_TO_IMPROVE: { title: "Areas to improve", filter: "to_improve_comments" },
  ADDITIONAL_COMMENTS: { title: "Three quick wins", filter: "additional_comments" },
};

export const Paragraphs = {
  IS_TEAM_360: {
    firstParagraph:
      "Within the questionnaire are three questions that ask the team for their comments about the team. We’ve asked them what they feel the team does well, what it can improve upon and anything else they feel would help the team develop further.",
    secondParagraph:
      "The comments are written verbatim as the platform does not edit or amend what’s been written by the team in any way. It may include errors, spelling mistakes and very occasionally, inappropriate language.",
  },
  NOT_TEAM_360: {
    firstParagraph:
      "Within the questionnaire are three questions that ask your stakeholders to comment on your team. We ask them what they feel the team does well, what it can improve upon and anything else they feel would help the team develop further.",
    secondParagraph:
      "The comments are written verbatim as the platform does not edit or amend what’s been written in any way. It may include errors, spelling mistakes and very occasionally, inappropriate language.",
  },
};
